<ng-content></ng-content>
<ng-container *ngIf="buttons.length">
  <ng-container *ngIf="mobileView">
    <button mat-icon-button [matMenuTriggerFor]="menu">
      <mat-icon>more_vert</mat-icon>
    </button>
    <mat-menu #menu="matMenu">
      <ng-container *ngFor="let button of buttons">
        <button (click)="handleClick(button.functionOrRoute)" mat-menu-item
                [disabled]="button.enabled !== undefined && !button.enabled"
                type="button">
          <mat-icon *ngIf="!button.iconPosition || button.iconPosition === 'left'">{{ button.icon }}</mat-icon>
          {{ button.text ?? button.tooltip }}
          <mat-icon *ngIf="button.iconPosition === 'right'" class="right">{{ button.icon }}</mat-icon>
        </button>
      </ng-container>
    </mat-menu>
  </ng-container>
  <ng-container *ngIf="!mobileView">
    <ng-container *ngFor="let button of buttons">
      <button *ngIf="button.toggle === undefined || button.toggle === true"
              (click)="handleClick(button.functionOrRoute)" class="mat-{{ button.color }}" mat-flat-button
              [disabled]="button.enabled !== undefined && !button.enabled"
              [style.z-index]="(button.zIndex ?? 'initial')"
              [class.icon-only]="button.tooltip"
              [matTooltip]="button.tooltip ?? null"
              type="button">
        <mat-icon *ngIf="!button.iconPosition || button.iconPosition === 'left'">{{ button.icon }}</mat-icon>
        <ng-container *ngIf="button.text">{{ button.text }}</ng-container>
        <mat-icon *ngIf="button.iconPosition === 'right'" class="right">{{ button.icon }}</mat-icon>
      </button>
    </ng-container>
  </ng-container>
</ng-container>
